<div class="au-mat-check-all-option">
	<mat-checkbox
		color="primary"
		class="mat-option"
		[indeterminate]="isIndeterminate()"
		[checked]="isChecked()"
		(click)="$event.stopPropagation()"
		(change)="toggleSelection($event)"
	>
		{{ text }}
	</mat-checkbox>
</div>
